import reportingUnit from "./reportingunit";
import notification from "./notification";
import reportingUnitList from "./reportingUnitList";
import favouriteFilters from "./favouriteFilters";
import userpermission from "./userpermission";
import approvals from "./approvals";
import gllist from "./gllist";
import reports from "./reports";
import dataprocessing from "./dataprocessing";
import queuemanagement from "./queuemanagement";
import { storeGet } from "@/store/store-utils";
import {
    COMMENTARY_AI,
    VARIANCE_ANALYSIS_MESSAGES,
    SL_COMMENTARY,
    SL_CONTEXT_STORAGE_KEY,
    BASE_PAGE_STATE_STORAGE_KEY,
    ACTUAL_FILTER_STORAGE_KEY,
    FORECAST_FILTER_STORAGE_KEY,
} from "../utils/constants";

const createDefaultSlCommentaryDialogState = () => ({
    aiProforma: '',
    aiForecast: '',
    aiResponseText: '',
    lastGeneratedVariant: '',
    summaryProforma: '',
    summaryForecast: '',
    summaryResponseText: '',
    lastSummaryVariant: '',
    aiLoadingProforma: false,
    aiLoadingForecast: false,
    summaryLoadingProforma: false,
    summaryLoadingForecast: false,
    lastAction: null,
});

const { SL_DATA } = VARIANCE_ANALYSIS_MESSAGES;

function persistSlContext(context) {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }
    try {
        if (context && Object.keys(context).length) {
            window.sessionStorage.setItem(SL_CONTEXT_STORAGE_KEY, JSON.stringify(context));
        } else {
            window.sessionStorage.removeItem(SL_CONTEXT_STORAGE_KEY);
        }
    } catch (error) {
        console.warn('[VarianceAnalysis Store]: Failed to persist SL context', error);
    }
}

const failedSessionPersistence = new Set();
const SESSION_STORAGE_SAFE_BYTES = 4 * 1024 * 1024; // 4MB safety limit

function persistSessionState(key, value) {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }
    if (failedSessionPersistence.has(key)) {
        return;
    }
    try {
        if (value === undefined || value === null) {
            window.sessionStorage.removeItem(key);
            return;
        }

        const serializedValue = JSON.stringify(value);
        if (serializedValue.length > SESSION_STORAGE_SAFE_BYTES) {
            failedSessionPersistence.add(key);
            console.warn(`[VarianceAnalysis Store]: Skipping persistence for ${key}; payload exceeds ${SESSION_STORAGE_SAFE_BYTES} bytes.`);
            return;
        }

        window.sessionStorage.setItem(key, serializedValue);
    } catch (error) {
        failedSessionPersistence.add(key);
        try {
            window.sessionStorage.removeItem(key);
        } catch (cleanupError) {
            // Ignore cleanup errors
        }
        console.warn(`[VarianceAnalysis Store]: Failed to persist ${key}`, error);
    }
}

function hydrateSessionState(key, fallback = null) {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return fallback;
    }
    try {
        const stored = window.sessionStorage.getItem(key);
        return stored ? JSON.parse(stored) : fallback;
    } catch (error) {
        console.warn(`[VarianceAnalysis Store]: Failed to hydrate ${key}`, error);
        return fallback;
    }
}
const moduleStore = {
    namespaced: true,
    modules:{
        reportingUnit,
        reportingUnitList,
        favouriteFilters,
        userpermission,
        notification,
        approvals,
        reports,
        gllist,
        dataprocessing,
        queuemanagement
    },
    state: {
        reportingUnitSearchResults: [],
        menu: [
            { product: true, title: 'Commentary Management Application', bgcolor: 'caccounting', label_id: 'commentary_management_application_title' },
            // { button: true, title: 'Create Analysis', href: '/tds/ar#add' },
            // {
            //   title: 'Dashboard', icon: 'mdi mdi-view-dashboard-outline', href: '/pbc/dashboard',
            // },
            // {
            //     title: 'Dashboard', icon: 'mdi mdi-chart-box', href: '/varianceanalysis/dashboard',
            // },
            {
                title: 'Actual Cycle', icon: '/img/navicon/ActualCycle.svg', href: '/varianceanalysis/actualanalysis', label_id: 'commentary_actual_menu_label',
            },
            {
                title: 'Forecast Cycle', icon: '/img/navicon/Forecast.svg', href: '/varianceanalysis/forecastanalysis', label_id: 'commentary_forecast_menu_label',
            },
            {
                title: 'My Reporting Units', icon: '/img/navicon/Profit.svg', href: '/varianceanalysis/myreportingunits', label_id: 'commentary_my_reporting_units_menu_label', hideForSuperAdmin: true
            },
            // { divider: true },
            // { header: true, title: 'Admin' },
            { title: 'Materiality', icon: '/img/navicon/Materiality.svg', href: '/varianceanalysis/threshold', right: "commentary", action: ["admin"], label_id: 'commentary_materiality_menu' },
            { title: 'Role Management', icon: '/img/navicon/UserPermissions.svg', href: '/varianceanalysis/accessrights', right: "commentary", action: ["admin"], label_id: 'commentary_role_management_label_menu' },
            { title: 'GL & Drill Down Selection', icon: '/img/navicon/GLSelection.svg', href: '/varianceanalysis/glselection', right: "commentary", action: ["admin"], label_id: 'commentary_gl_drilldown_menu' },
            { title: 'Approvals', icon: '/img/navicon/Approvals.svg', href: '/varianceanalysis/approvals', right: "commentary", action: ["approve"], label_id: 'commentary_approvals_label_menu' },
            { title: 'User Permissions', icon: '/img/navicon/UserPermissions.svg', href: '/varianceanalysis/userpermission', right: "commentary_permission_user", label_id: 'commentary_user_permissions_label_menu' },
            { title: 'Data Processing', icon: '/img/navicon/DataProcessing.svg', href: '/varianceanalysis/dataprocessing', right: "commentary_permission_user", label_id: 'commentary_data_processing_label_menu' },
            { title: 'Email Notification', icon: '/img/navicon/EmailNotification.svg', href: '/varianceanalysis/emailnotification', right: "commentary", action: ["superadmin"], label_id: 'commentary_email_notification_label_menu' },
            { header: true, title: 'Reports Download', icon: '/img/navicon/ReportDownload.svg' },
            { title: 'All Unit Cycle Report', icon: '', href: '/varianceanalysis/cyclereport', label_id: 'commentary_ai_label_menu' },
            { title: 'All Unit Data Report', icon: '', href: '/varianceanalysis/datareport', label_id: 'commentary_ai_label_menu' },
            { title: 'Materiality Reports', icon: '', href: '/varianceanalysis/materialityreports', right: "commentary", action: ["admin", "superadmin", "approve"], label_id: 'commentary_ai_label_menu' },
            { title: 'User Access Report', icon: '', href: '/varianceanalysis/useraccessreport', right: "commentary", action: ["admin", "superadmin", "approve"], label_id: 'commentary_ai_label_menu' },
            { title: 'Approvals Report', icon: '', href: '/varianceanalysis/approvalsreport', right: "commentary", action: ["approve", "superadmin"], label_id: 'commentary_ai_label_menu' },
            // { title: 'Data Centre Report', icon: '', href: '/varianceanalysis/datacentreport', right: "commentary", action: ["superadmin"], label_id: 'commentary_ai_label_menu' }, // To be added when data centre report is ready.
            { header: true, title: 'Settings', icon: '/img/navicon/SettingIcon.svg' },
            { title: 'GL Layout Configuration', icon: '', href: '/varianceanalysis/glmanagement', right: "commentary", action: ["superadmin"], label_id: 'commentary_gl_list_label_menu' },
            // { title: 'AI Settings', icon: '', href: '/varianceanalysis/ai', right: "commentary", action: ["superadmin"], label_id: 'commentary_ai_label_menu' },
            { title: 'Workflow Configuration', icon: '', href: '/varianceanalysis/workflow', right: "commentary", action: ["superadmin"], label_id: 'commentary_workflow_label_menu' },
            { title: 'Queue Management', icon: '', href: '/varianceanalysis/queue', right: "commentary", action: ["superadmin"], label_id: 'commentary_queue_management_label_menu' },
        ],
        filter: {},
        forecastfilter: hydrateSessionState(FORECAST_FILTER_STORAGE_KEY, {}),
        actualfilter: hydrateSessionState(ACTUAL_FILTER_STORAGE_KEY, {}),
        actualhierarchydata: {},
        forecasthierarchydata: {},
        previousActualFilterState: {},
        previousForecastFilterState: {},
        actualFilterStatus: [],
        forecastFilterStatus: [],
        // Base.vue filter state (persists on navigation)
        baseSelectedFilter: [0, 1, -1, 5, 6, -2, 7, 4, 3, 9],
        baseCustomFiltersToggle: false,
        // Flag to skip reload when navigating back from GLBreakdown
        skipReloadOnBack: false,
        // Base.vue page state (persists when navigating to GLBreakdown and back)
        basePageState: hydrateSessionState(BASE_PAGE_STATE_STORAGE_KEY, null),
        materialityViewPeriods: [],
        // Revenue Breakup state
        revenueBreakupData: {
            breakdownData: [],
            clientbyclientData: [],
            clientbyclientFullData: [],
            expandedGroups: [],
            viewMode: 'grouped',
            loading: false,
            selectedCommentary: {},
            revenueAIProforma: '',
            revenueAIForecast: '',
            cycleId: null,
            // Context data
            ispreparer: false,
            isPendingLocal: false,
            isPendingRegional: false,
            isSpecialRu: false,
            tablecolors: { heading: { a: '#d0dcff', b: '#efcef4' }, body: { a: '', b: '' } },
            revenueAILoadingProforma: false,
            revenueAILoadingForecast: false,
            isTyping: false,
            isThresholdExceedRevenueCommentary: false,
            revenueCommentaryGenAiBtntab: false,
            actualLabel: 'Actual',
            proformaLabel: 'Proforma',
            forecastLabel: 'Forecast',
            clientTypeHeaders: [],
            clientByClientHeaders: [],
            commentarycycledata: {},
            selectedreportingunit: '',
            reportingunitdata: [],
            selectedFilter: [-1, 0, 1, 5, -2, 6, 7, 4],
            customFiltersToggle: false,
        },
        // Net Sales Breakup state
        netSalesBreakupData: {
            breakdownData: [],
            clientbyclientData: [],
            clientbyclientFullData: [],
            expandedGroups: [],
            viewMode: 'grouped',
            loading: false,
            selectedCommentary: {},
            netSalesAIProforma: '',
            netSalesAIForecast: '',
            cycleId: null,
            // Context data
            ispreparer: false,
            isPendingLocal: false,
            isPendingRegional: false,
            isSpecialRu: false,
            tablecolors: { heading: { a: '#d0dcff', b: '#efcef4' }, body: { a: '', b: '' } },
            netSalesAILoadingProforma: false,
            netSalesAILoadingForecast: false,
            isTyping: false,
            isThresholdExceedNetSalesCommentary: false,
            selectedFilter: [-1, 0, 1, 5, -2, 6, 7, 4],
            customFiltersToggle: false,
            netSalesCommentaryGenAiBtntab: false,
            actualLabel: 'Actual',
            proformaLabel: 'Proforma',
            forecastLabel: 'Forecast',
            clientTypeHeaders: [],
            clientByClientHeaders: [],
            commentarycycledata: {},
            selectedreportingunit: '',
            reportingunitdata: [],
        },
        // AI Features state
        aiFeatures: [],
        aiFeatureLoading: false,
        aiFeatureError: null,
        SLData: {},
        slCommentaryDialog: createDefaultSlCommentaryDialogState(),
        trendline: {
            cache: {},
            loading: false,
            activeKey: '',
            errorMap: {},
            logsCache: {},
            logsLoading: false,
            logsActiveId: '',
            logsErrorMap: {},
        },
    },
    mutations: {
        setReportingUnitSearchResults(state, d) {
            state.reportingUnitSearchResults = d;
        },
        setSLData(state, d) {
            state.SLData = d;
            persistSlContext(state.SLData);
        },
        clearSLData(state) {
            state.SLData = {};
            persistSlContext(null);
        },
        // Update a specific field within SLData
        updateSlContextField(state, { field, value }) {
            if (state.SLData) {
                state.SLData = {
                    ...state.SLData,
                    [field]: value,
                };
                persistSlContext(state.SLData);
            }
        },
        // Update selectedGLCommentary within SLData to refresh breadcrumbs status
        updateSelectedGLCommentary(state, payload) {
            if (state.SLData) {
                state.SLData = {
                    ...state.SLData,
                    selectedGLCommentary: {
                        ...(state.SLData.selectedGLCommentary || {}),
                        ...payload,
                    },
                };
                persistSlContext(state.SLData);
            }
        },
        setSlCommentaryDialogState(state, payload = {}) {
            state.slCommentaryDialog = {
                ...state.slCommentaryDialog,
                ...payload,
            };
        },
        resetSlCommentaryDialogState(state) {
            state.slCommentaryDialog = createDefaultSlCommentaryDialogState();
        },
        SET_MATERIALITY_VIEW_PERIODS(state, payload) {
            state.materialityViewPeriods = payload;
        },
        setFilters(state, d) {
            state.filter = d
        },
        setForecastFilters(state, d) {
            state.forecastfilter = d || {};
            persistSessionState(FORECAST_FILTER_STORAGE_KEY, state.forecastfilter);
        },
        setActualFilters(state, d) {
            state.actualfilter = d || {};
            persistSessionState(ACTUAL_FILTER_STORAGE_KEY, state.actualfilter);
        },
        setForecastFiltersHieararchy(state, d) {
            state.forecasthierarchydata = d || {};
            // persistSessionState(FORECAST_HIERARCHY_STORAGE_KEY, state.forecasthierarchydata);
        },
        setActualFiltersHieararchy(state, d) {
            state.actualhierarchydata = d || {};
            // persistSessionState(ACTUAL_HIERARCHY_STORAGE_KEY, state.actualhierarchydata);
        },
        setPreviousActualFilterState(state, d) {
            state.previousActualFilterState = d;
        },
        setPreviousForecastFilterState(state, d) {
            state.previousForecastFilterState = d;
        },
        addActualFilterStatus(state, d) {
            state.actualFilterStatus.push(d)
        },
        popActualFilterStatus(state) {
            state.actualFilterStatus.pop()

        },
        addForecastFilterStatus(state, d) {
            state.forecastFilterStatus.push(d)
        },
        popForecastFilterStatus(state) {
            state.forecastFilterStatus.pop()

        },
        // Base.vue filter mutations
        setBaseSelectedFilter(state, filter) {
            state.baseSelectedFilter = filter;
        },
        setBaseCustomFiltersToggle(state, toggle) {
            state.baseCustomFiltersToggle = toggle;
        },
        setSkipReloadOnBack(state, skip) {
            state.skipReloadOnBack = skip;
        },
        // Base.vue page state mutations (for preserving state on back navigation)
        setBasePageState(state, pageState) {
            state.basePageState = pageState || null;
            persistSessionState(BASE_PAGE_STATE_STORAGE_KEY, state.basePageState);
        },
        clearBasePageState(state) {
            state.basePageState = null;
            persistSessionState(BASE_PAGE_STATE_STORAGE_KEY, null);
        },
        // Revenue Breakup mutations
        setRevenueBreakupData(state, data) {
            state.revenueBreakupData = { ...state.revenueBreakupData, ...data };
        },
        clearRevenueBreakupData(state) {
            state.revenueBreakupData = {
                breakdownData: [],
                clientbyclientData: [],
                clientbyclientFullData: [],
                expandedGroups: [],
                viewMode: 'grouped',
                loading: false,
                selectedCommentary: {},
                revenueAIProforma: '',
                revenueAIForecast: '',
                cycleId: null,
                ispreparer: false,
                isPendingLocal: false,
                isPendingRegional: false,
                isSpecialRu: false,
                tablecolors: { heading: { a: '#d0dcff', b: '#efcef4' }, body: { a: '', b: '' } },
                revenueAILoadingProforma: false,
                revenueAILoadingForecast: false,
                isTyping: false,
                isThresholdExceedRevenueCommentary: false,
                revenueCommentaryGenAiBtntab: false,
                actualLabel: 'Actual',
                proformaLabel: 'Proforma',
                forecastLabel: 'Forecast',
                clientTypeHeaders: [],
                clientByClientHeaders: [],
                commentarycycledata: {},
                selectedreportingunit: '',
                reportingunitdata: [],
                selectedFilter: [-1, 0, 1, 5, -2, 6, 7, 4],
                customFiltersToggle: false,
            };
        },
        // Net Sales Breakup mutations
        setNetSalesBreakupData(state, data) {
            state.netSalesBreakupData = { ...state.netSalesBreakupData, ...data };
        },
        clearNetSalesBreakupData(state) {
            state.netSalesBreakupData = {
                breakdownData: [],
                clientbyclientData: [],
                clientbyclientFullData: [],
                expandedGroups: [],
                viewMode: 'grouped',
                loading: false,
                selectedCommentary: {},
                netSalesAIProforma: '',
                netSalesAIForecast: '',
                cycleId: null,
                ispreparer: false,
                isPendingLocal: false,
                isPendingRegional: false,
                isSpecialRu: false,
                tablecolors: { heading: { a: '#d0dcff', b: '#efcef4' }, body: { a: '', b: '' } },
                netSalesAILoadingProforma: false,
                netSalesAILoadingForecast: false,
                isTyping: false,
                isThresholdExceedNetSalesCommentary: false,
                netSalesCommentaryGenAiBtntab: false,
                actualLabel: 'Actual',
                proformaLabel: 'Proforma',
                forecastLabel: 'Forecast',
                clientTypeHeaders: [],
                clientByClientHeaders: [],
                commentarycycledata: {},
                selectedreportingunit: '',
                reportingunitdata: [],
                selectedFilter: [-1, 0, 1, 5, -2, 6, 7, 4],
                customFiltersToggle: false,
            };
        },
        // AI Features mutations
        setAiFeatures(state, features) {
            state.aiFeatures = features;
        },
        setAiFeatureLoading(state, loading) {
            state.aiFeatureLoading = loading;
        },
        setAiFeatureError(state, error) {
            state.aiFeatureError = error;
        },
        updateAiFeature(state, updatedFeature) {
            const index = state.aiFeatures.findIndex(feature => feature.id === updatedFeature.id);
            if (index !== -1) {
                state.aiFeatures.splice(index, 1, updatedFeature);
            }
        },
        setTrendlineLoading(state, flag) {
            state.trendline.loading = flag;
        },
        setTrendlineActiveKey(state, contextKey) {
            state.trendline.activeKey = contextKey;
        },
        setTrendlineData(state, { contextKey, data }) {
            if (!contextKey) {
                return;
            }
            state.trendline.cache = {
                ...state.trendline.cache,
                [contextKey]: data,
            };
        },
        clearTrendlineError(state, contextKey) {
            if (!contextKey) {
                state.trendline.errorMap = {};
                return;
            }
            const nextErrorMap = { ...state.trendline.errorMap };
            delete nextErrorMap[contextKey];
            state.trendline.errorMap = nextErrorMap;
        },
        setTrendlineError(state, { contextKey, message }) {
            if (!contextKey) {
                return;
            }
            state.trendline.errorMap = {
                ...state.trendline.errorMap,
                [contextKey]: message,
            };
        },
        setTrendlineLogsLoading(state, flag) {
            state.trendline.logsLoading = flag;
        },
        setTrendlineLogsActiveId(state, contextKey) {
            state.trendline.logsActiveId = contextKey;
        },
        setTrendlineLogs(state, { contextKey, data }) {
            if (!contextKey) {
                return;
            }
            state.trendline.logsCache = {
                ...state.trendline.logsCache,
                [contextKey]: data,
            };
        },
        clearTrendlineLogsError(state, contextKey) {
            if (!contextKey) {
                state.trendline.logsErrorMap = {};
                return;
            }
            const nextErrorMap = { ...state.trendline.logsErrorMap };
            delete nextErrorMap[contextKey];
            state.trendline.logsErrorMap = nextErrorMap;
        },
        setTrendlineLogsError(state, { contextKey, message }) {
            if (!contextKey) {
                return;
            }
            state.trendline.logsErrorMap = {
                ...state.trendline.logsErrorMap,
                [contextKey]: message,
            };
        },
        resetTrendline(state) {
            state.trendline = {
                cache: {},
                loading: false,
                activeKey: '',
                errorMap: {},
                logsCache: {},
                logsLoading: false,
                logsActiveId: '',
                logsErrorMap: {},
            };
        },
    },
    actions: {
        async fetchAccessHierarchy({ commit, rootState, state }, { axios, filter, manualRefresh }) {
            const cycleType = filter.filter.cycletype;
            const cacheKey = `_pendingAccessHierarchy_${cycleType}`;

            // If a request is already in-flight for this cycle type, reuse it
            if (!manualRefresh && state[cacheKey]) {
                return state[cacheKey];
            }

            const promise = (async () => {
                try {
                    const response = await storeGet(axios, rootState, "/v3/varianceanalysis/analysis/getaccesshierarchy", filter.filter);
                    if (response.data.status === "success") {
                        const data = response.data.data[0] || response.data.data;
                        if (cycleType === "Actual") commit("setActualFiltersHieararchy", data);
                        else if (cycleType === "Forecast") commit("setForecastFiltersHieararchy", data);
                    }
                    return { status: response.data.status, message: response.data.message };
                } catch (error) {
                    console.error('[VarianceAnalysis Store]: fetchAccessHierarchy error', error);
                    throw error;
                } finally {
                    state[cacheKey] = null;
                }
            })();

            state[cacheKey] = promise;
            return promise;
        },
        async searchReportingUnits({ commit, rootState }, { axios, code }) {
            try {
                if (!code || code.length < 3) {
                     commit('setReportingUnitSearchResults', []);
                     return;
                }

                const { data } = await storeGet(axios, rootState, "/v2/varianceanalysis/reportingunit/getRUFiltersBasedOnSearch", { code });
                
                if (data?.status !== "success") {
                    commit('setReportingUnitSearchResults', []);
                    return;
                }
                const reportingUnits = data?.data ?? [];

                const usedIds = new Set();
                const transformed = reportingUnits.reduce((acc, { _id, code, name, cycle, network, region, country, type }) => {
                    if (_id && !usedIds.has(_id)) {
                        usedIds.add(_id);
                        acc.push({ _id, name: `${code} - ${name}`, cycle, network, region, country, type });
                    }
                    return acc;
                }, []);
                
                commit('setReportingUnitSearchResults', transformed);

                if (transformed.length === 0) {
                     commit('sbError', "No Reporting Units", { root: true });
                }

            } catch (error) {
                console.error('[VarianceAnalysis Store]: searchReportingUnits error', error);
                commit('sbError', error.message || "Unknown error!", { root: true });
                throw error;
            }
        },
        async getNetworkDetails({ rootState }, { axios, payload }) {
            try {
                // Flatten legacy POST body shapes: { data: {...} } or { filter: {...} } → flat params
                const rawParams = payload?.data || payload?.filter || payload || {};
                const response = await storeGet(axios, rootState, "/v2/varianceanalysis/hierarchy/getnetworkdetails", rawParams);
                return response;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: getNetworkDetails error', error);
                throw error;
            }
        },
        async getGlList({ rootState }, { axios, payload }) {
            try {
                const reporting_type = payload?.reporting_type || "pl";
                const response = await storeGet(axios, rootState, "/v2/varianceanalysis/gllist/get", { reporting_type });
                return response;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: getGlList error', error);
                throw error;
            }
        },
        async saveApprovalsRequest(_, { axios, id, payload }) {
            try {
                const response = await axios.post("/v2/varianceanalysis/hierarchy/saveapprovalsrequest/" + id, payload);
                return response;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: saveApprovalsRequest error', error);
                throw error;
            }
        },
        async getPendingRequests({ rootState }, { axios }) {
            try {
                const response = await storeGet(axios, rootState, '/v2/varianceanalysis/hierarchy/getpendingrequest');
                return response;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: getPendingRequests error', error);
                throw error;
            }
        },
        async cacheSLData({ commit }, payload) {
            try {
                commit('setSLData', payload);
                return true;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: cacheSLData error', error);
                commit('sbError', SL_DATA.CACHE_ERROR, { root: true });
                throw error;
            }
        },
        async clearSLData({ commit }) {
            try {
                commit('clearSLData');
                return true;
            } catch (error) {
                console.error('[VarianceAnalysis Store]: clearSLData error', error);
                commit('sbError', SL_DATA.CLEAR_ERROR, { root: true });
                throw error;
            }
        },
        async fetchAiFeatures({ commit }, axiosInstance) {
            commit('setAiFeatureLoading', true);
            commit('setAiFeatureError', null);

            try {
                const response = await axiosInstance.post('/v2/ai/get-all-features');
                if (response && response.data && response.data.status !== 'success') {
                    throw new Error('Failed to fetch AI features');
                }

                const features = response?.data?.features || [];
                commit('setAiFeatures', features);
                return features;

            } catch (error) {
                console.error('Error fetching AI features:', error);
                commit('setAiFeatureError', error.message || 'Unknown error occurred');
                throw error;
            } finally {
                commit('setAiFeatureLoading', false);
            }
        },

        async updateAiFeature({ commit }, { axiosInstance, data }) {
            try {
                const payload = { data: [data] };
                const response = await axiosInstance.post(`/v2/client/update-ai-feature/${data.id}`, payload);

                // Update the feature in the local state
                commit('updateAiFeature', data);

                return response;
            } catch (error) {
                console.error('Error updating AI feature:', error);
                throw error;
            }
        },

        async updateAiFeatureByClient({ commit }, { axiosInstance, data }) {
            try {
                const payload = { data: [data] };
                const response = await axiosInstance.post(`/v2/ai/updateFeatureById/${data.id}`, payload);

                // Update the feature in the local state
                commit('updateAiFeature', data);

                return response;
            } catch (error) {
                console.error('Error updating AI feature by client:', error);
                throw error;
            }
        },
        async fetchTrendlineData({ commit, rootState }, { axios, filter, contextKey, successMessage = 'Trendline data fetched successfully' }) {
            if (!axios || typeof axios.get !== 'function') {
                const message = 'Axios instance missing for trendline fetch';
                commit('setTrendlineError', { contextKey, message });
                commit('sbError', message, { root: true });
                console.error('[VarianceAnalysis Store]: fetchTrendlineData missing axios instance');
                return;
            }

            commit('setTrendlineActiveKey', contextKey || '');
            commit('setTrendlineLoading', true);
            if (contextKey) {
                commit('clearTrendlineError', contextKey);
            }

            try {
                const reportingType = filter?.reporting_type
                    || filter?.reportingType
                    || filter?.filter?.reporting_type
                    || filter?.filter?.reportingType
                    || '';

                const nextFilter = (filter && typeof filter === 'object') ? { ...filter } : {};
                if (reportingType && !nextFilter.reporting_type) {
                    nextFilter.reporting_type = reportingType;
                }

                const response = await storeGet(axios, rootState, '/v3/varianceanalysis/analysis/gettrend/', nextFilter);
                if (!response?.data || response.data.status !== 'success') {
                    throw new Error(response?.data?.message || 'Failed to fetch trendline data');
                }

                const trendData = Array.isArray(response.data.data) ? response.data.data : [];
                if (contextKey) {
                    commit('setTrendlineData', { contextKey, data: trendData });
                }

                if (successMessage && trendData.length > 0) {
                    commit('sbSuccess', successMessage, { root: true });
                }
            } catch (error) {
                const message = error?.response?.data?.message || error.message || 'Failed to fetch trendline data';
                const requestNotFound = /request not found/i.test(message);
                if (requestNotFound && contextKey) {
                    commit('setTrendlineData', { contextKey, data: [] });
                    commit('clearTrendlineError', contextKey);
                    console.warn('[VarianceAnalysis Store]: trendline request not found, returning empty dataset');
                    return;
                }

                commit('setTrendlineError', { contextKey, message });
                commit('sbError', message, { root: true });
                console.error('[VarianceAnalysis Store]: fetchTrendlineData error', error);
                throw error;
            } finally {
                commit('setTrendlineLoading', false);
            }
        },
            async fetchTrendlineLogs({ commit, rootState }, { axios, contextKey, commentaryId, cycleType = 'Actual', successMessage = 'Activity log ready' }) {
                if (!axios || typeof axios.get !== 'function') {
                    const message = 'Axios instance missing for activity log fetch';
                    if (contextKey) {
                        commit('setTrendlineLogsError', { contextKey, message });
                    }
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: fetchTrendlineLogs missing axios instance');
                    return;
                }

                if (!commentaryId) {
                    const message = 'Commentary identifier missing for activity log fetch';
                    if (contextKey) {
                        commit('setTrendlineLogsError', { contextKey, message });
                    }
                    commit('sbError', message, { root: true });
                    console.warn('[VarianceAnalysis Store]: fetchTrendlineLogs called without commentaryId');
                    return;
                }

                const effectiveCycleType = cycleType || 'Actual';
                commit('setTrendlineLogsActiveId', contextKey || '');
                commit('setTrendlineLogsLoading', true);
                if (contextKey) {
                    commit('clearTrendlineLogsError', contextKey);
                }

                try {
                    const url = `/v3/varianceanalysis/analysis/getlogs/${commentaryId}/f/${effectiveCycleType}`;
                    const response = await storeGet(axios, rootState, url);
                    if (!response?.data || response.data.status !== 'success') {
                        throw new Error(response?.data?.message || 'Failed to fetch activity log');
                    }

                    const logData = Array.isArray(response.data.data) ? response.data.data : [];
                    if (contextKey) {
                        commit('setTrendlineLogs', { contextKey, data: logData });
                    }

                    if (successMessage) {
                        commit('sbSuccess', successMessage, { root: true });
                    }
                } catch (error) {
                    const message = error?.response?.data?.message || error.message || 'Failed to fetch activity log';
                    if (contextKey) {
                        commit('setTrendlineLogsError', { contextKey, message });
                    }
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: fetchTrendlineLogs error', error);
                    throw error;
                } finally {
                    commit('setTrendlineLogsLoading', false);
                }
            },
            async updateRevenueAiState({ commit }, payload = {}) {
                commit('setRevenueBreakupData', payload);
                return true;
            },
            async generateSlCommentaryAI({ commit }, { axios, cycleId, glcodeId, variant, featureName = '', requestType = '', resource = 'netsales' }) {
                const messages = COMMENTARY_AI.MESSAGES;

                if (!axios || typeof axios.post !== 'function') {
                    const message = 'Axios instance missing for SL AI generation';
                    commit('setSlCommentaryDialogState', { aiResponseText: '', lastGeneratedVariant: '' });
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: generateSlCommentaryAI missing axios instance');
                    return false;
                }

                if (!cycleId || !glcodeId || !variant) {
                    const message = !glcodeId ? messages.MISSING_CONTEXT : messages.MISSING_CYCLE;
                    commit('sbError', message, { root: true });
                    return false;
                }

                const normalizedVariant = String(variant).toLowerCase();
                const isProforma = normalizedVariant === 'proforma';
                const isForecast = normalizedVariant === 'forecast';

                commit('setSlCommentaryDialogState', {
                    aiLoadingProforma: isProforma,
                    aiLoadingForecast: isForecast,
                    lastGeneratedVariant: normalizedVariant,
                });

                try {
                    const endpoint = resource === 'revenue'
                        ? COMMENTARY_AI.ENDPOINTS.REVENUE
                        : COMMENTARY_AI.ENDPOINTS.NET_SALES;

                    const response = await axios.post(endpoint, {
                        cycle: cycleId,
                        type_of_data: normalizedVariant,
                        glcode: glcodeId,
                        feature_name: featureName,
                        request_type: requestType,
                    });

                    if (!response?.data || response.data.status !== 'success') {
                        throw new Error(response?.data?.message || messages.GENERATION_ERROR);
                    }

                    const aiContent = response.data?.message?.content;
                    if (typeof aiContent !== 'string' || !aiContent.trim()) {
                        throw new Error(messages.EMPTY_RESPONSE);
                    }

                    const text = aiContent.trim();
                    const nextState = {
                        aiResponseText: text,
                        lastGeneratedVariant: normalizedVariant,
                    };
                    if (isProforma) {
                        nextState.aiProforma = '';
                    }
                    if (isForecast) {
                        nextState.aiForecast = '';
                    }

                    commit('setSlCommentaryDialogState', nextState);
                    commit('sbSuccess', messages.GENERATION_SUCCESS, { root: true });
                    return true;
                } catch (error) {
                    const message = error?.message || messages.GENERATION_ERROR;
                    commit('setSlCommentaryDialogState', {
                        aiResponseText: '',
                        lastGeneratedVariant: '',
                    });
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: generateSlCommentaryAI error', error);
                    throw error;
                } finally {
                    commit('setSlCommentaryDialogState', {
                        aiLoadingProforma: false,
                        aiLoadingForecast: false,
                    });
                }
            },
            async generateSlCommentarySummary({ commit }, { axios, cycleId, glcodeId, variant, featureName = '', requestType = '' }) {
                const messages = COMMENTARY_AI.MESSAGES;

                if (!axios || typeof axios.post !== 'function') {
                    const message = 'Axios instance missing for SL summary generation';
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: generateSlCommentarySummary missing axios instance');
                    return false;
                }

                if (!cycleId || !glcodeId || !variant) {
                    const message = !glcodeId ? messages.MISSING_CONTEXT : messages.MISSING_CYCLE;
                    commit('sbError', message, { root: true });
                    return false;
                }

                const normalizedVariant = String(variant).toLowerCase();
                const isProforma = normalizedVariant === 'proforma';
                const isForecast = normalizedVariant === 'forecast';

                commit('setSlCommentaryDialogState', {
                    summaryLoadingProforma: isProforma,
                    summaryLoadingForecast: isForecast,
                    lastSummaryVariant: normalizedVariant,
                });

                try {
                    const response = await axios.post(COMMENTARY_AI.ENDPOINTS.SUMMARY, {
                        cycle: cycleId,
                        type_of_data: normalizedVariant,
                        glcode: glcodeId,
                        feature_name: featureName,
                        request_type: requestType,
                    });

                    if (!response?.data || response.data.status !== 'success') {
                        throw new Error(response?.data?.message || messages.GENERATION_ERROR);
                    }

                    const aiContent = response.data?.message?.content || response.data?.message;
                    if (typeof aiContent !== 'string' || !aiContent.trim()) {
                        throw new Error(messages.EMPTY_RESPONSE);
                    }

                    commit('setSlCommentaryDialogState', {
                        summaryResponseText: aiContent.trim(),
                        lastSummaryVariant: normalizedVariant,
                    });
                    commit('sbSuccess', messages.GENERATION_SUCCESS, { root: true });
                    return true;
                } catch (error) {
                    const message = error?.message || messages.GENERATION_ERROR;
                    commit('setSlCommentaryDialogState', {
                        summaryResponseText: '',
                        lastSummaryVariant: '',
                    });
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: generateSlCommentarySummary error', error);
                    throw error;
                } finally {
                    commit('setSlCommentaryDialogState', {
                        summaryLoadingProforma: false,
                        summaryLoadingForecast: false,
                    });
                }
            },
            async executeSlCommentaryRequest({ commit }, { axios, url, body, actionType, successMessage, errorMessage, infoMessage, infoOnSuccess = false }) {
                if (!axios || typeof axios.post !== 'function') {
                    const message = errorMessage || 'Axios instance missing for SL commentary request';
                    commit('setSlCommentaryDialogState', {
                        lastAction: {
                            type: actionType,
                            status: 'error',
                            message,
                            timestamp: Date.now(),
                        },
                    });
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: executeSlCommentaryRequest missing axios instance');
                    return false;
                }

                commit('setSlCommentaryDialogState', {
                    lastAction: {
                        type: actionType,
                        status: 'loading',
                        timestamp: Date.now(),
                    },
                });

                try {
                    const response = await axios.post(url, body);
                    if (!response?.data || response.data.status !== 'success') {
                        throw new Error(response?.data?.message || errorMessage || 'Operation failed');
                    }

                    commit('setSlCommentaryDialogState', {
                        lastAction: {
                            type: actionType,
                            status: 'success',
                            timestamp: Date.now(),
                        },
                    });

                    if (infoOnSuccess && infoMessage) {
                        commit('sbInfo', infoMessage, { root: true });
                    } else if (successMessage) {
                        commit('sbSuccess', successMessage, { root: true });
                    }
                    return true;
                } catch (error) {
                    const message = error?.message || errorMessage || 'Operation failed';
                    commit('setSlCommentaryDialogState', {
                        lastAction: {
                            type: actionType,
                            status: 'error',
                            message,
                            timestamp: Date.now(),
                        },
                    });
                    commit('sbError', message, { root: true });
                    console.error('[VarianceAnalysis Store]: executeSlCommentaryRequest error', error);
                    throw error;
                }
            },
            async approveSlCommentary({ dispatch }, { axios, payload, isBulk = false, role, filter = {}, data = {} }) {
                const url = isBulk ? SL_COMMENTARY.ENDPOINTS.APPROVE_BULK : SL_COMMENTARY.ENDPOINTS.APPROVE_SINGLE;
                const body = {
                    id: payload,
                    role,
                    filter,
                    data,
                };

                const successMessage = isBulk ? SL_COMMENTARY.MESSAGES.BULK_APPROVE_SUCCESS : SL_COMMENTARY.MESSAGES.APPROVE_SUCCESS;
                const errorMessage = SL_COMMENTARY.MESSAGES.APPROVE_ERROR;

                return dispatch('executeSlCommentaryRequest', {
                    axios,
                    url,
                    body,
                    actionType: `${SL_COMMENTARY.ACTION_TYPES.APPROVE}${isBulk ? '-bulk' : ''}`,
                    successMessage,
                    errorMessage,
                });
            },
            async rejectSlCommentary({ dispatch }, { axios, payload, isBulk = false, role, filter = {}, data = {} }) {
                const url = isBulk ? SL_COMMENTARY.ENDPOINTS.REJECT_BULK : SL_COMMENTARY.ENDPOINTS.REJECT_SINGLE;
                const body = {
                    id: payload,
                    role,
                    filter,
                    data,
                };

                const errorMessage = SL_COMMENTARY.MESSAGES.REJECT_ERROR;
                const infoMessage = isBulk ? SL_COMMENTARY.MESSAGES.BULK_REJECT_INFO : SL_COMMENTARY.MESSAGES.REJECT_INFO;

                return dispatch('executeSlCommentaryRequest', {
                    axios,
                    url,
                    body,
                    actionType: `${SL_COMMENTARY.ACTION_TYPES.REJECT}${isBulk ? '-bulk' : ''}`,
                    errorMessage,
                    infoMessage,
                    infoOnSuccess: true,
                });
            },
            async saveSlCommentary({ dispatch }, { axios, url, body }) {
                return dispatch('executeSlCommentaryRequest', {
                    axios,
                    url,
                    body,
                    actionType: SL_COMMENTARY.ACTION_TYPES.SAVE,
                    successMessage: SL_COMMENTARY.MESSAGES.SAVE_SUCCESS,
                    errorMessage: SL_COMMENTARY.MESSAGES.SAVE_ERROR,
                });
            },
            async saveRegionalApprovalReason({ dispatch }, { axios, url, body }) {
                return dispatch('executeSlCommentaryRequest', {
                    axios,
                    url,
                    body,
                    actionType: SL_COMMENTARY.ACTION_TYPES.SAVE_REASON,
                    successMessage: SL_COMMENTARY.MESSAGES.SAVE_REASON_SUCCESS,
                    errorMessage: SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR,
                });
            },
            async addSlCommentary({ dispatch }, { axios, url, body }) {
                return dispatch('executeSlCommentaryRequest', {
                    axios,
                    url,
                    body,
                    actionType: SL_COMMENTARY.ACTION_TYPES.ADD,
                    successMessage: SL_COMMENTARY.MESSAGES.ADD_SUCCESS,
                    errorMessage: SL_COMMENTARY.MESSAGES.ADD_ERROR,
                });
            },
            async generateRevenueCommentaryAI({ state, commit, rootGetters }, { axios, requestType, variant, rowData = {} }) {
                const messages = COMMENTARY_AI.MESSAGES;
                const revenueState = state.revenueBreakupData || {};

                if (revenueState.isThresholdExceedRevenueCommentary) {
                    commit('sbError', messages.THRESHOLD_BLOCKED, { root: true });
                    return false;
                }

                const target = Object.keys(rowData).length ? rowData : revenueState.selectedCommentary || {};
                const glcodeId = target?.glcode_detail?._id || '';

                if (!glcodeId) {
                    commit('sbError', messages.MISSING_CONTEXT, { root: true });
                    return false;
                }

                const cycleId = target?.cycle?._id
                    || target?.cycleId
                    || revenueState.cycleId
                    || revenueState.commentarycycledata?._id
                    || '';

                if (!cycleId) {
                    commit('sbError', messages.MISSING_CYCLE, { root: true });
                    return false;
                }

                const featureName = revenueState.commentarycycledata?.name || target?.feature_name || '';
                const axiosInstance = axios || rootGetters?.axiosObject;

                if (!axiosInstance || typeof axiosInstance.post !== 'function') {
                    commit('sbError', messages.GENERATION_ERROR, { root: true });
                    return false;
                }

                const isProforma = variant === 'proforma';
                const isForecast = variant === 'forecast';

                commit('setRevenueBreakupData', {
                    revenueAILoadingProforma: isProforma,
                    revenueAILoadingForecast: isForecast,
                    isTyping: true,
                });

                try {
                    const response = await axiosInstance.post(COMMENTARY_AI.ENDPOINTS.REVENUE, {
                        cycle: cycleId,
                        type_of_data: variant,
                        glcode: glcodeId,
                        feature_name: featureName,
                        request_type: requestType,
                    });

                    if (!response?.data || response.data.status !== 'success') {
                        throw new Error(response?.data?.message || messages.GENERATION_ERROR);
                    }

                    const aiContent = response.data?.message?.content;
                    if (typeof aiContent !== 'string' || !aiContent.trim()) {
                        throw new Error(messages.EMPTY_RESPONSE);
                    }

                    const trimmedContent = aiContent.trim();

                    const nextState = {};
                    if (isProforma) {
                        nextState.revenueAIProforma = trimmedContent;
                    }
                    if (isForecast) {
                        nextState.revenueAIForecast = trimmedContent;
                    }

                    commit('setRevenueBreakupData', nextState);
                    commit('sbSuccess', messages.GENERATION_SUCCESS, { root: true });
                    return true;
                } catch (error) {
                    console.error('[VarianceAnalysis Store]: generateRevenueCommentaryAI error', error);
                    const message = error?.message || messages.GENERATION_ERROR;
                    commit('sbError', message, { root: true });
                    throw error;
                } finally {
                    commit('setRevenueBreakupData', {
                        revenueAILoadingProforma: false,
                        revenueAILoadingForecast: false,
                        isTyping: false,
                    });
                }
            },
    },
    getters: {
        getAiFeatures: (state) => state.aiFeatures,
        getAiFeatureLoading: (state) => state.aiFeatureLoading,
        getAiFeatureError: (state) => state.aiFeatureError,
        getAiFeatureByName: (state) => (name) => {
            return state.aiFeatures.find(feature => feature.name === name);
        },
        getAiFeatureById: (state) => (id) => {
            return state.aiFeatures.find(feature => feature.id === id);
        },
        getTrendlineData: (state) => (key) => {
            if (!key) {
                return null;
            }
            return state.trendline.cache[key] || null;
        },
        getTrendlineLoading: (state) => state.trendline.loading,
        getTrendlineActiveKey: (state) => state.trendline.activeKey,
        getTrendlineError: (state) => (key) => {
            if (!key) {
                return '';
            }
            return state.trendline.errorMap[key] || '';
        },
        getTrendlineLogs: (state) => (key) => {
            if (!key) {
                return [];
            }
            return state.trendline.logsCache[key] || [];
        },
        getTrendlineLogsLoading: (state) => state.trendline.logsLoading,
        getTrendlineLogsActiveId: (state) => state.trendline.logsActiveId,
        getTrendlineLogsError: (state) => (key) => {
            if (!key) {
                return '';
            }
            return state.trendline.logsErrorMap[key] || '';
        },
        getSLData: (state) => state.SLData,
        getSlAiResponseText: (state) => state.slCommentaryDialog.aiResponseText,
        getSlAiLoadingProforma: (state) => state.slCommentaryDialog.aiLoadingProforma,
        getSlAiLoadingForecast: (state) => state.slCommentaryDialog.aiLoadingForecast,
        getSlLastGeneratedVariant: (state) => state.slCommentaryDialog.lastGeneratedVariant,
        getSlSummaryResponseText: (state) => state.slCommentaryDialog.summaryResponseText,
        getSlSummaryLoadingProforma: (state) => state.slCommentaryDialog.summaryLoadingProforma,
        getSlSummaryLoadingForecast: (state) => state.slCommentaryDialog.summaryLoadingForecast,
        getSlLastSummaryVariant: (state) => state.slCommentaryDialog.lastSummaryVariant,
        getSlCommentaryLastAction: (state) => state.slCommentaryDialog.lastAction,
        getRevenueBreakupData: (state) => state.revenueBreakupData,
        getRevenueAiProforma: (state) => state.revenueBreakupData.revenueAIProforma,
        getRevenueAiForecast: (state) => state.revenueBreakupData.revenueAIForecast,
        getRevenueAiLoadingProforma: (state) => state.revenueBreakupData.revenueAILoadingProforma,
        getRevenueAiLoadingForecast: (state) => state.revenueBreakupData.revenueAILoadingForecast,
        getRevenueAiTyping: (state) => state.revenueBreakupData.isTyping,
        getRevenueCommentaryThresholdStatus: (state) => state.revenueBreakupData.isThresholdExceedRevenueCommentary,
        getRevenueCommentaryGenAiFlag: (state) => state.revenueBreakupData.revenueCommentaryGenAiBtntab,
        getRevenueCommentaryCycle: (state) => state.revenueBreakupData.commentarycycledata,
        getRevenueCommentaryCycleId: (state) => state.revenueBreakupData.cycleId,
        getSelectedRevenueCommentary: (state) => state.revenueBreakupData.selectedCommentary,
        materialityViewPeriods: (state) => state.materialityViewPeriods,
    },
};

// Remove conflicting state properties to prevent Vuex warnings/errors
// These state fields were being overridden by modules with the same name
if (moduleStore.state && typeof moduleStore.state === 'object') {
    const cleanState = { ...moduleStore.state };
    const conflictingKeys = ['reportingUnit', 'reportingUnitList', 'favouriteFilters', 'userpermission', 'notification', 'approvals', 'reports', 'gllist', 'dataprocessing'];
    
    conflictingKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(cleanState, key)) {
             delete cleanState[key];
        }
    });

    // Convert state to a function to ensure a fresh clean object is returned
    moduleStore.state = () => ({ ...cleanState });
}

export default moduleStore;